var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"readonly-text",style:('height:' + _vm.options.height + 'px'),domProps:{"innerHTML":_vm._s(_vm.options.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }